// useSelectedCssModule.js
// React hook to select the appropriate CSS module (PC or mobile) based on device type.
// Usage: const styles = useSelectedCssModule(pcModule, mobileModule);

import { useState, useEffect } from 'react';

/**
 * Selects the correct CSS module for the current device (PC or mobile).
 * @param {object} pcModule - The PC CSS module import.
 * @param {object} mobileModule - The mobile CSS module import.
 * @returns {object} The selected CSS module.
 */
export default function useSelectedCssModule(pcModule, mobileModule) {
  const [styles, setStyles] = useState(pcModule);

  useEffect(() => {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    setStyles(isMobile ? mobileModule : pcModule);
  }, [pcModule, mobileModule]);

  return styles;
}
